import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { memo } from 'react';
import { SidebarMainItem } from '../sidebar-items-expanded/components/sidebar-main-item';
import { SidebarSubItem } from '../sidebar-items-expanded/components/sidebar-sub-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { AppSidebarProps as Props } from './types';

export const AppSidebar = memo(({ className, state, menu }: Props) => {
  const { title, subItems, description } = menu;
  if (isEmpty(menu)) return null;

  return (
    <Styled.Wrapper
      className={classnames('AppSidebar', className, { open: state.value })}
      sx={SX.root}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={SX.header}
      >
        <Styled.Logo src="/assets/images/ai-ark-text-logo.svg" alt="logo" />
        <Icon name="sidebar" onClick={state.onFalse} size={18} sxx={SX.icon} />
      </Stack>
      <Box sx={SX.content}>
        <SidebarMainItem title={title} description={description} />
        {subItems?.map((sub) => (
          <SidebarSubItem
            key={sub.title}
            icon={sub.icon}
            title={sub.title}
            route={sub.route}
          />
        ))}
      </Box>
    </Styled.Wrapper>
  );
});

AppSidebar.displayName = 'AppSidebar';
